import "./RootComponent.css";
import { ReactNode } from "react";

function RootComponent({ children }: { children: ReactNode }) {
  return (
    <div id="root-component" className="d-flex">
      {children}
    </div>
  );
}

export default RootComponent;
